export function checkEmail(email, emptyOk) {
    if (emptyOk && !email) {
        return true;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function checkPhone(phone, emptyOk) {
    if (emptyOk && !phone) {
        return true;
    }
    return /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/.test(phone);

}